import React from 'react'
import './possibility.css'
import possibilityImage from '../../assets/possibility.png'

const Possibility = () => {
  return (
    <div className='omit__possibility section__padding' id='possibility'>
      <div className='omit__possibility-img'>
        <img src={possibilityImage} alt='possibility' />
      </div>
      <div className='omit__possibility-content'>
        <h1 className='gradient__text'>
          Light up your projects, the possibilities are beyond your imagination
        </h1>
        <p>
          We are capable to build an innovative entertainment solution, with the
          main to improve the UX of the customer's end clients. It will help the
          customer to create a convenient-to-use online presence with flawless
          user journeys, advanced filters, and informative galleries. On top of
          that, comprehensive series of QA rounds were run in order to make the
          solution stable and high-performing.
        </p>
        <h4>Request Our Pricing To Get Started</h4>
      </div>
    </div>
  )
}

export default Possibility
